export default {
  title: "Ylvi",
  version: "1.9.1",
  buildDate: "20250401120914",
};
